(function () {
  const LengthImageSelector = customElements.get('length-image-selector');
  if (!LengthImageSelector) return;

  const proto = LengthImageSelector.prototype;
  const baseConnected = proto.connectedCallback;
  const baseSetEventListeners = proto.setEventListeners;
  const baseOnLengthChange = proto.onLengthChange;
  const baseUpdateVariant = proto.updateVariant;
  const baseReloadSelector = proto.reloadSelector;
  const baseUpdateActiveState = proto.updateActiveState;

  function isIg46Enabled(el) {
    return el && el.hasAttribute('data-ig46-enabled');
  }

  proto.isMixedLengthValue = function (value) {
    return /gemixt|gemist|mixed|gemischt/i.test(value || '');
  };

  proto.findLengthItem = function (lengthValue) {
    if (!lengthValue) return null;
    const normalized = lengthValue.replace(/\s/g, '').toLowerCase();
    let match = null;
    this.querySelectorAll('.length-image-selector-item').forEach(item => {
      const value = (item.getAttribute('data-length-value') || '').replace(/\s/g, '').toLowerCase();
      if (value === normalized) match = item;
    });
    return match;
  };

  proto.findMixedLengthItem = function () {
    const defaultValue = this.getAttribute('data-default-length-value');
    if (defaultValue) {
      const byDefault = this.findLengthItem(defaultValue);
      const defaultInput = byDefault?.querySelector('input[type="radio"]:not([disabled])');
      if (defaultInput) return byDefault;
    }
    let match = null;
    this.querySelectorAll('.length-image-selector-item:not(.ig-8mm-option)').forEach(item => {
      const input = item.querySelector('input[type="radio"]');
      if (!input || input.disabled) return;
      if (this.isMixedLengthValue(item.getAttribute('data-length-value'))) match = item;
    });
    return match;
  };

  proto.isIg468mmItem = function (item) {
    return !!(item && item.classList.contains('ig-8mm-option'));
  };

  proto.isIg46TestActive = function () {
    if (typeof window.isId46TestActive === 'function' && window.isId46TestActive()) return true;
    const html = document.documentElement;
    const body = document.body;
    if (html.classList.contains('ig-id46-v1') || html.classList.contains('ig-id46-v2')) return true;
    if (body && (body.classList.contains('ig-id46-v1') || body.classList.contains('ig-id46-v2'))) return true;
    const probe = document.querySelector('.ig-8mm-option');
    return !!(probe && window.getComputedStyle(probe).display !== 'none');
  };

  proto.canSelectLengthInput = function (item, input) {
    if (!item || !input) return false;
    if (this.isIg468mmItem(item) && this.isIg46TestActive()) return true;
    if (!input.disabled) return true;
    if (!this.isIg468mmItem(item)) return false;
    return !!(item.getAttribute('data-ig46-dummy-handle') || item.getAttribute('data-variant-id'));
  };

  proto.refreshLengthItems = function () {
    this.lengthItems = this.querySelectorAll('.length-image-selector-item');
    this.setEventListeners();
  };

  proto.bindLengthItemClick = function (item) {
    const input = item.querySelector('input[type="radio"]');
    if (!this.canSelectLengthInput(item, input)) return;
    input.removeEventListener('click', this.onLengthChangeBound);
    input.addEventListener('click', this.onLengthChangeBound);
  };

  proto.selectLengthItem = function (item, input, preserveInteraction) {
    if (!this.canSelectLengthInput(item, input)) return false;
    if (input.disabled) {
      input.disabled = false;
      input.removeAttribute('disabled');
    }
    input.checked = true;
    this.updateActiveState(item);
    this.updateHeaderValue(item.getAttribute('data-length-value'));
    const variantId = item.getAttribute('data-variant-id');
    const fullImageUrl = item.getAttribute('data-full-image');
    if (fullImageUrl) this.updateMainGalleryImage(fullImageUrl);
    if (preserveInteraction) this.userInteracted = true;
    this.updateVariant(variantId, fullImageUrl);
    return true;
  };

  proto.selectDefaultMixedLength = function () {
    if (!isIg46Enabled(this)) return;
    if (this.userInteracted || window.__ig46UserSelected8mm) return;
    if (typeof window.isIg468mmSelectionActive === 'function' && window.isIg468mmSelectionActive()) return;
    const mixedItem = this.findMixedLengthItem();
    if (!mixedItem) return;
    const input = mixedItem.querySelector('input[type="radio"]:not([disabled])');
    if (!input) return;
    if (!input.checked) {
      this.selectLengthItem(mixedItem, input, false);
      return;
    }
    this.updateActiveState(mixedItem);
    this.updateHeaderValue(mixedItem.getAttribute('data-length-value'));
    this.updateVariant(mixedItem.getAttribute('data-variant-id'), mixedItem.getAttribute('data-full-image'));
  };

  proto.restoreLengthSelection = function (lengthValue) {
    if (lengthValue) {
      const item = this.findLengthItem(lengthValue);
      const input = item?.querySelector('input[type="radio"]');
      if (this.selectLengthItem(item, input, this.userInteracted)) return;
    }
    const mixedItem = this.findMixedLengthItem();
    const mixedInput = mixedItem?.querySelector('input[type="radio"]:not([disabled])');
    if (this.selectLengthItem(mixedItem, mixedInput, this.userInteracted)) return;
    const checked = this.querySelector('.length-image-selector-item input:checked:not([disabled])');
    if (checked) {
      const item = checked.closest('.length-image-selector-item');
      if (this.selectLengthItem(item, checked, this.userInteracted)) return;
    }
    const firstAvailable = this.querySelector('.length-image-selector-item.available input:not([disabled])');
    if (firstAvailable) {
      this.selectLengthItem(firstAvailable.closest('.length-image-selector-item'), firstAvailable, false);
    }
  };

  proto.connectedCallback = function () {
    baseConnected.call(this);
    if (!isIg46Enabled(this)) return;
    requestAnimationFrame(() => {
      if (window.__ig46UserSelected8mm || this.querySelector('.ig-8mm-option.active')) return;
      this.selectDefaultMixedLength();
    });
    if (typeof window.ig46BindAll8mmItems === 'function') window.ig46BindAll8mmItems(this);
  };

  proto.setEventListeners = function () {
    if (isIg46Enabled(this)) {
      if (!this._clickDelegationBound) {
        this._clickDelegationBound = true;
        this.addEventListener('click', (event) => {
          const item = event.target.closest('.length-image-selector-item');
          if (!item || !this.contains(item)) return;
          const input = item.querySelector('input[type="radio"]');
          if (!input || event.target === input) return;
          if (this.isIg468mmItem(item) && this.isIg46TestActive()) {
            if (typeof window.activateIg468mmItem === 'function') window.activateIg468mmItem(item);
            return;
          }
          if (!this.canSelectLengthInput(item, input)) return;
          if (input.disabled) {
            input.disabled = false;
            input.removeAttribute('disabled');
          }
          input.checked = true;
          this.onLengthChange({ target: input });
        });
      }
      this.lengthItems = this.querySelectorAll('.length-image-selector-item');
      this.lengthItems.forEach(item => this.bindLengthItemClick(item));
      return;
    }
    baseSetEventListeners.call(this);
  };

  proto.onLengthChange = function (event) {
    if (!isIg46Enabled(this)) {
      baseOnLengthChange.call(this, event);
      return;
    }
    this.userInteracted = true;
    const input = event.target;
    const item = input.closest('.length-image-selector-item');
    if (this.isIg468mmItem(item)) {
      window.__ig46UserSelected8mm = true;
      if (typeof window.activateIg468mmItem === 'function') window.activateIg468mmItem(item);
      return;
    }
    window.__ig46UserSelected8mm = false;
    if (typeof window.ig46OnNon8mmLengthSelected === 'function') window.ig46OnNon8mmLengthSelected(item);
    baseOnLengthChange.call(this, event);
  };

  proto.updateActiveState = function (selectedItem) {
    if (isIg46Enabled(this)) {
      this.lengthItems = this.querySelectorAll('.length-image-selector-item');
    }
    baseUpdateActiveState.call(this, selectedItem);
  };

  proto.updateVariant = function (variantId, fullSizeImageSrc) {
    if (!isIg46Enabled(this)) {
      baseUpdateVariant.call(this, variantId, fullSizeImageSrc);
      return;
    }
    const activeItem = this.querySelector('.length-image-selector-item.active');
    if (activeItem && activeItem.classList.contains('ig-8mm-option')) {
      if (fullSizeImageSrc && this.userInteracted) this.updateMainGalleryImage(fullSizeImageSrc);
      if (typeof window.resolveIg468mmSelection === 'function') {
        window.resolveIg468mmSelection(() => {});
      } else if (typeof window.reapplyIg468mmFormVariant === 'function') {
        window.reapplyIg468mmFormVariant();
      }
      return;
    }
    if (!variantId) return;
    let productForm = document.querySelector(`#product-form-${this.sectionId}`);
    if (!productForm) {
      const host = this.closest('product-information');
      productForm = host?.querySelector('product-form form') || document.querySelector('product-form form');
    }
    if (!productForm) return;
    const variantSelect = productForm.querySelector('select[name="id"]');
    const variantInput = productForm.querySelector('input[name="id"]');
    if (variantInput) variantInput.value = variantId;
    if (variantSelect) variantSelect.value = variantId;
    if (typeof window.reapplyIg468mmFormVariant === 'function' && this.querySelector('.ig-8mm-option.active')) {
      window.reapplyIg468mmFormVariant();
      return;
    }
    if (typeof window.ig46SyncFormVariantId === 'function') window.ig46SyncFormVariantId(variantId);
    if (this.userInteracted) {
      const target = variantInput || variantSelect;
      if (target) target.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (this.userInteracted) {
      const variantData = this.getVariantById(variantId);
      if (variantData && typeof eventBus !== 'undefined') {
        eventBus.emit('variant:change', {
          sectionId: this.sectionId,
          variant: variantData,
          fetchURL: `${window.location.pathname}?variant=${variantId}`,
          productURL: window.location.pathname,
          isCombinedListing: false,
          fromLengthImageSelector: true
        });
      }
    }
  };

  proto.reloadSelector = function () {
    if (!isIg46Enabled(this)) {
      baseReloadSelector.call(this);
      return;
    }
    const selectedItem = this.querySelector('.length-image-selector-item input:checked')?.closest('.length-image-selector-item');
    const selectedLength = selectedItem?.getAttribute('data-length-value');
    const currentUrl = window.location.pathname;
    let sectionId = this.sectionId;
    if (sectionId.includes('template--')) sectionId = sectionId.replace('template--', '');
    const match = sectionId.match(/(\d+__[\w-]+)/);
    if (match) sectionId = match[1];
    const urlParams = new URLSearchParams(window.location.search);
    const marketParam = urlParams.get('market');
    let fetchUrl = `${currentUrl}?section_id=${sectionId}`;
    if (marketParam) fetchUrl += `&market=${marketParam}`;
    const currentVariant = urlParams.get('variant');
    if (currentVariant) fetchUrl += `&variant=${currentVariant}`;
    fetch(fetchUrl)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSelector = doc.querySelector('length-image-selector');
        if (!newSelector) return;
        const newItems = newSelector.querySelector('.length-image-selector-items');
        const currentItems = this.querySelector('.length-image-selector-items');
        if (!newItems || !currentItems) return;
        currentItems.innerHTML = newItems.innerHTML;
        this.refreshLengthItems();
        if (typeof window.ig46BindAll8mmItems === 'function') window.ig46BindAll8mmItems(this);
        const wasInteracted = this.userInteracted;
        if (typeof window.remountIg468mmOptions === 'function') {
          window.__ig46_8mmImages = null;
          window.__ig46_8mmVariants = null;
          window.remountIg468mmOptions();
        } else if (typeof window.syncIg468mmPurchase === 'function') {
          window.__ig46_8mmImages = null;
          window.__ig46_8mmVariants = null;
          window.syncIg468mmPurchase();
        }
        this.userInteracted = wasInteracted;
        if (window.__ig46UserSelected8mm || this.querySelector('.ig-8mm-option.active')) {
          if (typeof window.ig46BindAll8mmItems === 'function') window.ig46BindAll8mmItems(this);
          return;
        }
        if (!wasInteracted) this.selectDefaultMixedLength();
        else this.restoreLengthSelection(selectedLength);
      })
      .catch(() => {});
  };

  document.querySelectorAll('length-image-selector[data-ig46-enabled]').forEach(el => {
    if (typeof window.ig46BindAll8mmItems === 'function') window.ig46BindAll8mmItems(el);
    if (!el.userInteracted) el.selectDefaultMixedLength();
  });
})();
